module.exports = __webpack_public_path__ + "img/logo.c104d046.png";